import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Methodology } from "../components/Methodology";
import { Clients } from "../components/Clients";
import { Values } from "../components/Values";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { VideoSection } from "../components/VideoSection";
import { GallerySection } from "../components/GallerySection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { NewsSection } from "../components/NewsSection";
import { CookieBanner } from "../components/CookieBanner";
import { AnnouncementBar } from "../components/AnnouncementBar";

export default function Landing() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page" className="theme-public">
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Methodology />
        <VideoSection />
        <Clients />
        <GallerySection />
        <Values />
        <TestimonialsSection />
        <NewsSection />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
